import { useState } from "react";
import { toast } from "sonner";
import { Upload, FileText, Image as ImageIcon } from "lucide-react";
import { api, errMsg, openFile, fmtDate, useFetch } from "../../lib/api";

export function FileUpload({ meta = {}, onUploaded, label = "Upload file", accept = ".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.dwg,.docx", testid = "file-upload-input" }) {
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    Object.entries(meta).forEach(([k, v]) => v && fd.append(k, v));
    try {
      const r = await api.post("/files", fd);
      toast.success("Uploaded");
      onUploaded && onUploaded(r.data);
    } catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <label className="btn-outline-o cursor-pointer">
      <Upload className="h-4 w-4" />{busy ? "Uploading..." : label}
      <input data-testid={testid} type="file" accept={accept} className="hidden" onChange={pick} disabled={busy} />
    </label>
  );
}

export function FileList({ entity, entityId, projectId, category, canUpload = true }) {
  const q = new URLSearchParams();
  if (entity) q.set("entity", entity);
  if (entityId) q.set("entity_id", entityId);
  if (projectId) q.set("project_id", projectId);
  if (category) q.set("category", category);
  const { data, reload } = useFetch(`/e/documents?${q}`);
  return (
    <div className="space-y-2" data-testid="file-list">
      {canUpload && <FileUpload meta={{ entity, entity_id: entityId, project_id: projectId, category: category || "General" }} onUploaded={reload} />}
      {(data || []).length === 0 && <p className="text-xs text-neutral-400">No files attached yet.</p>}
      {(data || []).map((d) => (
        <button key={d.id} onClick={() => openFile(`/files/${d.id}`, d.original_filename).catch((e) => toast.error(errMsg(e)))}
          className="w-full flex items-center gap-3 rounded-xl border border-neutral-200 p-2.5 text-left hover:border-[#FF5A00] transition-colors" data-testid={`file-${d.id}`}>
          {d.content_type?.startsWith("image") ? <ImageIcon className="h-4 w-4 text-[#FF5A00]" /> : <FileText className="h-4 w-4 text-[#FF5A00]" />}
          <span className="text-sm flex-1 truncate">{d.name}</span>
          <span className="text-[11px] text-neutral-400">Rev {d.revision} · {fmtDate(d.created_at)} · {d.created_by_name}</span>
        </button>
      ))}
    </div>
  );
}
